import { defineBlocksWithJsonArray } from 'blockly/core';

const SERIAL_STYLE = 'beginner_serial_blocks';

const serialMonitorBlockDefinitions = [
  {
    type: 'beginner_serial_send',
    message0: 'send %1',
    args0: [{ type: 'input_value', name: 'VALUE' }],
    previousStatement: null,
    nextStatement: null,
    style: SERIAL_STYLE,
    tooltip: 'Sends a value to the Serial Monitor without starting a new line.',
    helpUrl: '',
  },
  {
    type: 'beginner_serial_send_character',
    message0: 'send character %1',
    args0: [{ type: 'input_value', name: 'CHAR', check: ['char', 'String'] }],
    previousStatement: null,
    nextStatement: null,
    style: SERIAL_STYLE,
    tooltip: 'Sends a single character to the Serial Monitor.',
    helpUrl: '',
  },
  {
    type: 'beginner_serial_send_line',
    message0: 'send line %1',
    args0: [{ type: 'input_value', name: 'VALUE' }],
    previousStatement: null,
    nextStatement: null,
    style: SERIAL_STYLE,
    tooltip: 'Sends a value to the Serial Monitor and then starts a new line.',
    helpUrl: '',
  },
  {
    type: 'beginner_serial_received_character',
    message0: 'received character',
    output: 'char',
    style: SERIAL_STYLE,
    tooltip: 'The latest character received from the Serial Monitor.',
    helpUrl: '',
  },
  {
    type: 'beginner_serial_received_number',
    message0: 'received number',
    output: 'Number',
    style: SERIAL_STYLE,
    tooltip: 'The latest number received from the Serial Monitor.',
    helpUrl: '',
  },
  {
    type: 'beginner_serial_received_text',
    message0: 'received text',
    output: 'String',
    style: SERIAL_STYLE,
    tooltip: 'The latest text received from the Serial Monitor.',
    helpUrl: '',
  },
  {
    type: 'beginner_serial_data_available',
    message0: 'data available?',
    output: 'Boolean',
    style: SERIAL_STYLE,
    tooltip: 'True when new information has arrived from the Serial Monitor.',
    helpUrl: '',
  },
  {
    type: 'beginner_serial_wait_data',
    message0: 'wait until data received',
    previousStatement: null,
    nextStatement: null,
    style: SERIAL_STYLE,
    tooltip: 'Waits until information arrives from the Serial Monitor.',
    helpUrl: '',
  },
];

export function registerBeginnerSerialMonitorBlocks(): void {
  defineBlocksWithJsonArray(serialMonitorBlockDefinitions);
}
